export const RECEIVE_COURSE_SEARCH_RESULTS = 'RECEIVE_SEARCH_RESULTS';
export const SORT_COURSE_SEARCH_RESULTS = 'SORT_SEARCH_RESULTS';
export const FETCH_COURSE_SEARCH_RESULTS = 'FETCH_SEARCH_RESULTS';
